
(function () {
  'use strict';

  function getMoment() {
    return document.querySelector('[data-moment-overlay], .arshe-moment-page, .arshe-moment-overlay, .arshe-moment-fullscreen');
  }

  function getMenuButton() {
    return document.querySelector(
      'summary[aria-controls*="menu"], button[aria-controls*="menu"], ' +
      'button.header__icon--menu, button[aria-label*="Menu" i], ' +
      'summary[aria-label*="Menu" i], .header__icon--menu'
    );
  }

  function getDrawer() {
    return document.querySelector(
      'menu-drawer, .menu-drawer-container, .menu-drawer, ' +
      '#menu-drawer, [id*="menu-drawer"]'
    );
  }

  function forceMenuAboveMoment() {
    var drawer = getDrawer();
    if (!drawer) return;

    drawer.style.setProperty('z-index', '2147483000', 'important');
    drawer.style.setProperty('position', 'fixed', 'important');
  }

  function openRealMenu() {
    var button = getMenuButton();
    var drawer = getDrawer();

    if (button) {
      // Do not close Moment. Trigger the theme's real menu control.
      button.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }));
      forceMenuAboveMoment();
      return true;
    }

    if (drawer) {
      // Fallback for themes where the drawer control is not a native button.
      drawer.classList.add('menu-opening', 'active', 'open');
      drawer.setAttribute('open', '');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('inert');
      drawer.style.setProperty('z-index', '2147483000', 'important');
      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      return true;
    }
    return false;
  }

  function interceptMomentMenu(e) {
    var target = e.target.closest(
      '.arshe-moment-page button[aria-label*="Menu" i], ' +
      '.arshe-moment-overlay button[aria-label*="Menu" i], ' +
      '.arshe-moment-page .moment-menu, ' +
      '.arshe-moment-overlay .moment-menu, ' +
      '.arshe-moment-page [data-moment-menu], ' +
      '.arshe-moment-overlay [data-moment-menu]'
    );

    if (!target) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    // Critical: never call the Moment close function here.
    openRealMenu();
  }

  function patchExistingMomentHandlers() {
    // Neutralize common V35-style handlers which close the moment before opening menu.
    document.querySelectorAll(
      '[data-moment-menu], .moment-menu, .arshe-moment-menu, ' +
      '.arshe-moment-page [aria-label*="Menu" i], .arshe-moment-overlay [aria-label*="Menu" i]'
    ).forEach(function (el) {
      el.addEventListener('click', function (e) {
        // Let the capture handler own this interaction.
      }, true);
    });
  }

  document.addEventListener('click', interceptMomentMenu, true);

  // Make sure the real drawer remains above the Moment overlay whenever it opens.
  var observer = new MutationObserver(function () {
    var drawer = getDrawer();
    if (drawer && (
      drawer.hasAttribute('open') ||
      drawer.classList.contains('active') ||
      drawer.classList.contains('menu-opening')
    )) {
      forceMenuAboveMoment();
    }
  });

  function init() {
    patchExistingMomentHandlers();
    forceMenuAboveMoment();

    if (document.body) {
      observer.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'open', 'aria-hidden', 'inert', 'style']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
